<script>
    import { diff } from 'deep-diff';
    export default {
        name: "MapboxLayer_FromTiles",
        render() {
            return null // Just does JS things. No DOM things.
        },
        props: [
            'name',
            'beforeLayerName',
            'geoJSON',
            'url',
            'tiles',
            'layers',
            'interactivity',
            'clusterSettings'
        ],
        data: function () {
            return {
                loaded: false,
                installedLayerIds: [],
            }
        },
        computed: {
            layerIds: function () {
                return this.layers.map((layer, idx) => this.name + '_' + layer.type + '_' + idx);
            }
        },
        methods: {
            onClick: function(featureEvent) {
                this.$emit('featureClick', featureEvent)
            },
            install: function () {
                if (!this.loaded) {
                    return
                }
                let map = this.$parent.map;
                let sourceOptions = {};
                if (this.clusterSettings) {
                    sourceOptions.cluster = true;
                    sourceOptions.clusterRadius = this.clusterSettings.clusterRadius;
                    sourceOptions.clusterProperties = this.clusterSettings.clusterProperties;
                }
                if (this.geoJSON + this.url + this.tiles > 1) {
                    console.warn('Layer is not defined correctly: ' + this.name)
                } else if (this.tiles) {
                    sourceOptions.type = 'vector';
                    sourceOptions.tiles = this.tiles;
                } else if (this.url) {
                    sourceOptions.type = 'vector';
                    sourceOptions.url = this.url;
                } else {
                    sourceOptions.type = 'geojson';
                    sourceOptions.data = this.geoJSON || {
                        type: 'FeatureCollection',
                        features: []
                    };
                }
                map.addSource(this.name, sourceOptions);

                this.layers.forEach((layer, idx) => {
                    layer = {...layer};
                    if (layer.id) {
                        console.warn('Layer has id that is overwritten: ' + this.name + ' ' + layer.id)
                    }
                    layer.id = this.layerIds[idx];
                    if (layer.source) {
                        console.warn('Layer has source that is overwritten: ' + this.name + ' ' + layer.source)
                    }
                    layer.source = this.name;

                  if (map.getLayer(this.beforeLayerName)) {
                    map.addLayer(layer, this.beforeLayerName);
                  } else {
                    map.addLayer(layer);
                  }
                    if (this.interactivity) {
                        map.on('click', layer.id, this.onClick)
                    }
                });
                this.installedLayerIds = this.layerIds;
            },
            uninstall: function () {
                if (!this.loaded) {
                    return
                }
                let map = this.$parent.map;
                this.installedLayerIds.forEach(id => {
                    map.off('click', id, this.onClick);
                    if (map.getLayer(id)) {
                        map.removeLayer(id);
                    } else {
                        console.warn('layer is being uninstalled but it is not installed: ' + this.name)
                    }
                });
                this.installedLayerIds = [];
                if (map.getSource(this.name)) {
                    map.removeSource(this.name);
                } else {
                    console.warn('source is being uninstalled but it is not installed: ' + this.name)
                }
            }
        },
        mounted: function () {
            let vue_this = this;
            this.$parent.map.on('load', function () {
                vue_this.loaded = true;
                vue_this.install();
            })
        },
        watch: {
            geoJSON: function () {
                let make_it_happen = () => {
                    let source = this.$parent.map.getSource(this.name);
                    if (source) {
                        source.setData(this.geoJSON || {
                            type: 'FeatureCollection',
                            features: []
                        });
                    } else {
                        setTimeout(make_it_happen, 100)
                    }
                };
                make_it_happen();
            },
            url: function () {
                this.uninstall();
                this.install();
            },
            tiles: function () {
              this.uninstall();
              this.install();
            },
            clusterSettings: function () {
                this.uninstall();
                this.install();
            },
            layers: function (newLayers, oldLayers) {
                if (oldLayers.length !== newLayers.length) {
                    this.uninstall();
                    this.install();
                    return;
                }
                let changes = diff(oldLayers, newLayers);
                if (!changes) {
                    return;
                }
                let map = this.$parent.map;
                for (const c of changes) {
                    const path = c.path;
                    const id = this.layerIds[path[0]];
                    if (path[1] === 'filter') {
                        map.setFilter(id, this.layers[path[0]].filter);
                    } else if (path[1] === 'paint') {
                      map.setPaintProperty(id, path[2], this.layers[path[0]].paint[path[2]]);
                    } else if (path[1] === 'layout') {
                      map.setLayoutProperty(id, path[2], this.layers[path[0]].layout[path[2]]);
                    } else {
                        this.uninstall(oldLayers);
                        this.install();
                        return;
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
